module.exports = __webpack_public_path__ + "static/img/erweima.59e849c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/erweima.png
// module id = Ugmy
// module chunks = 0